var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Instagram New Logo Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 7.02000067
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.9393583%",
    y1: "15.465716%",
    x2: "83.1623559%",
    y2: "85.2036559%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#395DFA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#544CED",
    offset: "21.6534791%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#903ACD",
    offset: "44.7643908%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D53592",
    offset: "68.3389075%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4306D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-9.2%",
    y: "-9.2%",
    width: "118.3%",
    height: "118.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.17000016,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-54.8%",
    y: "-54.8%",
    width: "209.6%",
    height: "209.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-5"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.85000079,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-31.9%",
    y: "-31.9%",
    width: "163.7%",
    height: "163.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.80800038,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-33.9%",
    y: "-33.9%",
    width: "167.8%",
    height: "167.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-7"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.48908662,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-43.2%",
    y: "-43.2%",
    width: "186.3%",
    height: "186.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.80800038,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-99.8%",
    y: "-99.8%",
    width: "299.6%",
    height: "299.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-9"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.6607495,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.83349018 C0,3.50717302 3.51011676,0 7.83349018,0 L14.4742021,0 C18.8005193,0 22.3076923,3.51011676 22.3076923,7.83349018 L22.3076923,14.4742021 C22.3076923,18.8005193 18.7975756,22.3076923 14.4742021,22.3076923 L7.83349018,22.3076923 C3.50717302,22.3076923 0,18.7975756 0,14.4742021 L0,7.83349018 Z M2.01923077,7.63721269 L2.01923077,14.6704796 C2.01923077,17.7673842 4.53448695,20.2884615 7.63721269,20.2884615 L14.6704796,20.2884615 C17.7673842,20.2884615 20.2884615,17.7732054 20.2884615,14.6704796 L20.2884615,7.63721269 C20.2884615,4.54030809 17.7732054,2.01923077 14.6704796,2.01923077 L7.63721269,2.01923077 C4.54030809,2.01923077 2.01923077,4.53448695 2.01923077,7.63721269 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-6.7%",
    y: "-6.7%",
    width: "113.4%",
    height: "113.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.0624716938 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M11.1538462,16.8269231 C8.02069228,16.8269231 5.48076923,14.287 5.48076923,11.1538462 C5.48076923,8.02069228 8.02069228,5.48076923 11.1538462,5.48076923 C14.287,5.48076923 16.8269231,8.02069228 16.8269231,11.1538462 C16.8269231,14.287 14.287,16.8269231 11.1538462,16.8269231 Z M11.1538462,14.8076923 C13.1718097,14.8076923 14.8076923,13.1718097 14.8076923,11.1538462 C14.8076923,9.13588264 13.1718097,7.5 11.1538462,7.5 C9.13588264,7.5 7.5,9.13588264 7.5,11.1538462 C7.5,13.1718097 9.13588264,14.8076923 11.1538462,14.8076923 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.2%",
    y: "-13.2%",
    width: "126.4%",
    height: "126.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.05 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Home",
    transform: "translate(-872.000000, -4093.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Instagram-New-Logo-Copy-2",
    transform: "translate(872.000000, 4093.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color-background"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "round-shape",
    fill: "#C5C5C5",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "bottom",
    fill: "url(#linearGradient-3)",
    filter: "url(#filter-4)",
    mask: "url(#mask-2)",
    cx: 15.2884615,
    cy: 14.3269231,
    r: 19.1346154
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-12",
    fill: "#F8443E",
    filter: "url(#filter-5)",
    mask: "url(#mask-2)",
    cx: 9.85576923,
    cy: 26.9711538,
    r: 16.0096154
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-13",
    fill: "#F86737",
    filter: "url(#filter-6)",
    mask: "url(#mask-2)",
    cx: 9.47115385,
    cy: 29.6634615,
    r: 13.2211538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-13",
    fill: "#F88330",
    filter: "url(#filter-7)",
    mask: "url(#mask-2)",
    cx: 9.75961538,
    cy: 29.8557692,
    r: 11.0096154
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-13",
    fill: "#FBBB45",
    filter: "url(#filter-8)",
    mask: "url(#mask-2)",
    cx: 9.75961538,
    cy: 31.1057692,
    r: 9.75961538
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-13",
    fill: "#FBE18A",
    filter: "url(#filter-9)",
    mask: "url(#mask-2)",
    cx: 9.66346154,
    cy: 32.3557692,
    r: 8.50961538
  })), /*#__PURE__*/React.createElement("g", {
    id: "Glyph",
    transform: "translate(3.846154, 3.846154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-22",
    fill: "#FFFFFF",
    cx: 17.0192308,
    cy: 5.19230769,
    r: 1.34615385
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.a22df17cac972c20596876a2a2603acc.svg";
export { ForwardRef as ReactComponent };